import React from "react";
import PropTypes from "prop-types";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { clx } from "../../../../../../../utils/Helpers";

const FileOpenButton = ({ url, label }) => {
  if (!url || !label) return null;
  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        className="review-profile-diff-file-open"
        onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
        aria-label={label}
      >
        <DownloadOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

FileOpenButton.propTypes = {
  url: PropTypes.string,
  label: PropTypes.string,
};

FileOpenButton.defaultProps = {
  url: undefined,
  label: undefined,
};

const ReviewDiffField = ({
  label,
  changed,
  display,
  oldValue,
  newValue,
  valueAccent,
  valueClassName,
  fileUrl,
  oldFileUrl,
  newFileUrl,
  fileOpenLabel,
}) => (
  <div className="review-profile-diff-field">
    <div className="company-view-field-label">{label}</div>
    {changed ? (
      <div
        className={clx("company-view-field-value", valueClassName)}
      >
        <div className="review-profile-diff-change">
          <span className="review-profile-diff-old-cell">
            <span className="review-profile-diff-old">{oldValue || "—"}</span>
            <FileOpenButton url={oldFileUrl} label={fileOpenLabel} />
          </span>
          <ArrowForwardIcon
            sx={{ fontSize: 14 }}
            className="review-profile-diff-arrow"
            aria-hidden
          />
          <span className="review-profile-diff-new-cell">
            <span className="review-profile-diff-new">{newValue || "—"}</span>
            <FileOpenButton url={newFileUrl} label={fileOpenLabel} />
          </span>
        </div>
      </div>
    ) : (
      <div
        className={clx(
          "company-view-field-value",
          valueClassName,
          {
            "company-view-field-value--accent": valueAccent,
          },
        )}
      >
        <span className="review-profile-diff-static-doc">
          <span className="review-profile-diff-static-doc-text">
            {display ?? "—"}
          </span>
          <FileOpenButton url={fileUrl} label={fileOpenLabel} />
        </span>
      </div>
    )}
  </div>
);

ReviewDiffField.propTypes = {
  label: PropTypes.string.isRequired,
  changed: PropTypes.bool.isRequired,
  display: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  oldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  newValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  valueAccent: PropTypes.bool,
  valueClassName: PropTypes.string,
  fileUrl: PropTypes.string,
  oldFileUrl: PropTypes.string,
  newFileUrl: PropTypes.string,
  fileOpenLabel: PropTypes.string,
};

ReviewDiffField.defaultProps = {
  display: undefined,
  oldValue: undefined,
  newValue: undefined,
  valueAccent: false,
  valueClassName: undefined,
  fileUrl: undefined,
  oldFileUrl: undefined,
  newFileUrl: undefined,
  fileOpenLabel: undefined,
};

export default ReviewDiffField;
